import Swiper from "swiper/swiper-bundle";
import $ from "jquery";

function headerSlider() {
  function initSlider() {
    const slider = new Swiper(".header-slider", {
      loop: true,
      // autoplay: {
      //   delay: 5000,
      // },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      keyboard: {
        enabled: true,
      },
      autoHeight: true,
      navigation: {
        nextEl: ".header-slider-next",
        prevEl: ".header-slider-prev",
      },
      pagination: {
        el: ".swiper-pagination--header",
        type: "bullets",
        clickable: true,
      },
      on: {
        init: function () {
          const controls = document.querySelector(".header-slider-controls");

          setTimeout(function () {
            controls.classList.add("initialized");
          }, 1000);
        },
      },
    });
  }

  const isPresent = document.getElementsByClassName("header-slider");
  if (isPresent.length > 0) {
    initSlider();
  }
}

export { headerSlider };

function moduleSliders() {
  function initSlider() {
    $(".module-slider").each(function (index, element) {
      var $this = $(this);
      var swiper = new Swiper(this, {
        loop: true,
        autoplay: false,
        autoHeight: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: $this.find(".module-slider-next")[0],
          prevEl: $this.find(".module-slider-prev")[0],
        },
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: $this.find(".swiper-pagination--module")[0],
          type: "bullets",
          clickable: true,
        },
      });
    });
  }

  const isPresent = document.getElementsByClassName("module-slider");
  if (isPresent.length > 0) {
    initSlider();
  }
}

export { moduleSliders };

function slidingSlider() {
  function initSlider() {
    const slider = new Swiper(".sliding-slider", {
      loop: true,
      // autoplay: {
      //   delay: 5000,
      // },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      keyboard: {
        enabled: true,
      },
      autoHeight: true,
      navigation: {
        nextEl: ".sliding-slider-next",
        prevEl: ".sliding-slider-prev",
      },
      pagination: {
        el: ".swiper-pagination--sliding",
        type: "bullets",
        clickable: true,
      },
    });
  }

  const isPresent = document.getElementsByClassName("sliding-slider");
  if (isPresent.length > 0) {
    initSlider();
  }
}

export { slidingSlider };
